import * as Config from '../../../../../../config';
import React from 'react';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';

import Content from '../../../../common/Content';
import SubMenu from '../../../../common/SubMenu';
import GridCardActions from './GridCardActions';
import ListV2 from '../../../../content/list/ListV2';
// import RadioButton from '../../../../automix/RadioButton';
import Tracks from './Tracks';

import usePageScroll from '../../../../../../hooks/usePageScroll';

import './Container.css';

const MTOP = 12;
function ConnectedContainer({ dimension, pathCustom = '' }) {
  let { url } = useRouteMatch();
  const { width, height } = dimension;

  let { onScroll } = usePageScroll();

  return (
    <div className={`global-page`} style={{ height }} onScroll={onScroll}>
      <Content name={`My Beatport`} isSticky={true} 
        stickyClassName={`global-sticky-menu`}
        contentClassName={`content-my-beatport`}
        styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
        subContent={(
          <div className='flexRow'>
            <div className={`flexRow slider-menu my-beatport-menu`}>
              <SubMenu to={`${url}/featured`} or={`${url}`} label={`Tracks`} />
              <SubMenu to={`${url}/artists`} label={`Artists`} />
              <SubMenu to={`${url}/labels`} label={`Labels`} />
            </div>
             {/* {(!window.location.pathname.includes(`artists`) && !window.location.pathname.includes(`labels`)) && <RadioButton className={'discover-radio-button'} />} */}
          </div>
        )}
      >
        <Switch>
          <Route exact path={[`${url}`, `${url}/featured`]}>
            <Tracks pathApi={`/my/beatport/tracks/?preorder=false&per_page=100${pathCustom}`} />
          </Route>
          <Route exact path={`${url}/artists`}>
            <GridCardActions id={`my-beatport-artists`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/my/beatport/artists/`}
              type={`artist`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite artists to start a feed of new releases.'}
            />
          </Route>
          <Route path={`${url}/artists/:refresh`} render={ props => (
            <GridCardActions id={`my-beatport-artists${props.match.params.refresh}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/my/beatport/artists/`}
              type={`artist`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite artists to start a feed of new releases.'}
            />
          )}/>
          <Route exact path={`${url}/labels`}>
            <GridCardActions id={`my-beatport-labels`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/my/beatport/labels/`}
              type={`label`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite labels to start a feed of new releases.'}
            />
          </Route>
          <Route path={`${url}/labels/:refresh`} render={ props => (
            <GridCardActions id={`my-beatport-labels${props.match.params.refresh}`} width={width}
              height={ height - (Config.TAB_BAR_GUTTER * 4.6) }
              perPage={5000} pathApi={`/my/beatport/labels/`}
              type={`label`}
              style={{marginTop: MTOP}}
              className={`no-border`}
              placeholder={'Follow your favorite labels to start a feed of new releases.'}
            />
          )} />
          <Route path={`${url}/collection`}>
            <ListV2
              pathApi={`/my/downloads/?is_available_for_streaming=true&per_page=100`}
              sortable={false}
              id={`collection`}
              width={width}
              height={height - (Config.TAB_BAR_GUTTER * 5.3)}
              size={Config.LIST_ROW_HEIGHT}
              style={{paddingTop: MTOP}}
              isLoadMore={true}
              type={`Full`}
              orderBy={[`default`] /* API - Any WORKS */}
              filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `label`, `genre_s`, `bpm`, `key_convert`]}
              filtersStyle={{position: `absolute`, top: 12, right: 105}}
              panelStyle={{ top: 65 }}
              automix={true}
              automixName={`Collection`}
              automixStyle={{ position: `absolute`, top: 0, left: `auto`, right: 0 }}
              from={`/collection`}
            />
          </Route>
        </Switch>
      </Content>
    </div>
  );
}

ConnectedContainer.propTypes = {
  dimension: PropTypes.object
}

const Container = connect(
  state => ({
    dimension: state.dimension,
    pathCustom: state.MBPathCustom ? state.MBPathCustom : ''
  })
)(ConnectedContainer);

export default Container;
